export enum RestaurantMenuTypes {
  dinning = 'dinning',
  drinks = 'drinks',
  bigGameRoom = 'big-game-room',
  cocktail = 'cocktail',
}
